import { useEffect, useState } from "react";
import { hivesApi } from "../../services/hivesApi";
import { Modal } from "../common/Modal";
import { Badge } from "../common/Badge";
import { DataTable } from "../common/DataTable";

const STATUS_TONE = { Pending: "neutral", Processing: "info", Completed: "success", Failed: "danger" };

/** "Batch History": past batch operations from app.BatchOperationLogs
 * (GET /api/hives/batch-history). */
export function BatchHistoryModal({ open, onClose }) {
  const [history, setHistory] = useState(null);

  useEffect(() => {
    if (open) {
      hivesApi.batchHistory().then((r) => setHistory(r.batch_history));
    }
  }, [open]);

  return (
    <Modal open={open} onClose={onClose} title="Batch Operation History" size="lg">
      <DataTable
        rows={history}
        loading={!history}
        rowKey="log_id"
        emptyTitle="No batch operations yet"
        emptyDescription="Batch updates, archives, and treatments you run will show up here."
        columns={[
          { key: "timestamp", header: "When", render: (r) => new Date(r.timestamp).toLocaleString() },
          { key: "operation_type", header: "Operation" },
          {
            key: "affected_hive_ids",
            header: "Hives Affected",
            render: (r) => {
              try {
                return JSON.parse(r.affected_hive_ids || "[]").length;
              } catch {
                return "—";
              }
            },
          },
          { key: "status", header: "Status", render: (r) => <Badge tone={STATUS_TONE[r.status]}>{r.status}</Badge> },
          { key: "error_message", header: "Error", render: (r) => r.error_message || "—" },
        ]}
      />
    </Modal>
  );
}
